<div class="modal-overlay" *ngIf="state">
    <div class="modal-content" attr.style="width:{{size.width}};height:{{size.height}}">
        <div class="modal-header" *ngIf="template.header">
            <ng-container *ngTemplateOutlet="template.header;"></ng-container>

        </div>
        <div class="modal-body">
            <ng-container *ngTemplateOutlet="template.body;"></ng-container>

        </div>
        <div class="modal-footer" *ngIf="template.footer">
            <ng-container *ngTemplateOutlet="template.footer;"></ng-container>
        </div>
    </div>
</div>